import { render, staticRenderFns } from "./report-tizhi.vue?vue&type=template&id=b1a46e98&scoped=true"
import script from "./report-tizhi.vue?vue&type=script&lang=ts"
export * from "./report-tizhi.vue?vue&type=script&lang=ts"
import style0 from "./report-tizhi.vue?vue&type=style&index=0&id=b1a46e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a46e98",
  null
  
)

export default component.exports